<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>卡密列表</el-breadcrumb-item>
        </el-breadcrumb>

        <!--添加 -->
        <el-form :inline="true" style="margin-top: 20px;">
            <el-form-item>
                <el-select size="small" v-model="sousuo.status" placeholder="请选择卡密状态">
                    <el-option v-for="item in options" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select size="small" v-model="sousuo.state" placeholder="请选择卡密批次状态">
                    <el-option v-for="item in options1" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select size="small" v-model="sousuo.batch" placeholder="请选择卡密批次名称">
                    <el-option v-for="item in optionsBatch" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="chongzhi">重置</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-plus" @click="OpenBianji()">添加</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="small" @click="exportExcel">导出Excel</el-button>
            </el-form-item>
        </el-form>

        <!-- 列表 -->
        <el-table size="small" ref="multipleTable" :data="DataList" element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" sortable type="index" label="序号"></el-table-column>
            <el-table-column align="center" sortable prop="batchName" label="卡密批次名称" width="180">
                <!-- <template slot-scope="scope">
                    {{ typeName(scope.row.batch) }}
                </template> -->
            </el-table-column>
            <el-table-column align="center" sortable prop="state" :formatter="State" label="批次状态"
                width="120"></el-table-column>
            <el-table-column align="center" sortable prop="status" :formatter="Status" label="卡密状态"
                width="120"></el-table-column>
            <el-table-column align="center" sortable prop="type" :formatter="Type" label="卡密类型"
                width="120"></el-table-column>
            <el-table-column align="center" sortable prop="number" label="卡密串" width="150"></el-table-column>
            <el-table-column align="center" sortable prop="money" label="面值" width="120"></el-table-column>
            <el-table-column align="center" sortable prop="createTime" label="创建时间" width="150">
                <template slot-scope="scope">
                    <div>{{ transformDate(scope.row.createTime) }}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" show-overflow-tooltip width="150px">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="upShenhe(scope.row)">修改状态</el-button>
                    <!-- <el-button size="mini" type="primary" @click="OpenBianji(scope.row)">修改</el-button>
                    <el-button size="mini" type="danger" @click="deleData(scope.row)">删除</el-button> -->
                </template>
            </el-table-column>
        </el-table>

        <!-- 编辑界面 -->
        <el-dialog title="添加" :visible.sync="editFormVisiible" width="40%">
            <el-form label-width="120px">
                <el-form-item label="面值">
                    <el-input size="small" v-model="xiugai.money" auto-complete="off" placeholder="请输入面值"></el-input>
                </el-form-item>
                <el-form-item label="数量">
                    <el-input size="small" v-model="xiugai.num" auto-complete="off" placeholder="请输入数量"></el-input>
                </el-form-item>
                <el-form-item label="卡密批次名称">
                    <el-select v-model="xiugai.batch" placeholder="请选择卡密批次名称">
                        <el-option v-for="item in optionsBatch" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="xiugai.type" placeholder="请选择类型">
                        <el-option v-for="item in options2" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click='closeDialog()'>取消</el-button>
                <el-button size="small" type="primary" :loading="loading" @click="addData()">添加</el-button>
            </div>
        </el-dialog>

        <!-- 修改状态-->
        <el-dialog title="修改状态界面" :visible.sync="editFormUpShenhe" width="30%">
            <el-form label-width="80px">
                <el-form-item label="状态">
                    <el-select v-model="status" placeholder="请选择状态">
                        <el-option v-for="item in options1" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click='closeUpShenhe()'>取消</el-button>
                <el-button size="small" type="primary" :loading="loading" @click="upShenheZuopin()">确定</el-button>
            </div>
        </el-dialog>

        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    </div>
</template>

<script>
import {
    getCardList,
    generateCards,
    getCardBatchList,
    upCard,
    exportCardList
} from "../../api/userMG";
import * as XLSX from 'xlsx/xlsx.mjs';
import { saveAs } from 'file-saver';
import Pagination from '../../components/Pagination'
export default {
    data() {
        return {
            DataList: [],
            loading: false,
            editFormVisiible: false,
            xiugai: {
                id: '',
                num: '',
                money: '',
                batch: '',
                type: ''
            },
            options: [{
                value: 0,
                label: '待使用'
            }, {
                value: 1,
                label: ' 已使用'
            }, {
                value: 2,
                label: '停用'
            }],
            options1: [{
                value: 0,
                label: '禁用'
            }, {
                value: 1,
                label: ' 启用'
            }],
            options2: [{
                value: 0,
                label: '钻石'
            }, {
                value: 1,
                label: '奖学金'
            }],
            money: '',
            state: '',
            status: '',
            number: '',
            batch: '',
            optionsBatch: [],
            sousuo: {
                status: '',
                state: '',
                batch: '',
            },
            status: '',
            editFormUpShenhe: false,
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 20,
                total: 10
            },
            data1: []
        }
    },
    created() {
        this.getdata(1)
        this.gteBatch()
    },
    // 注册组件
    components: {
        Pagination
    },
    computed: {
        typeName() {
            return batch => {
                let name = ''
                this.optionsBatch.forEach(item => {
                    if (item.value == batch) {
                        name = item.label
                    }
                })
                return name
            }
        }
    },
    methods: {
        exportExcel() {
            exportCardList({
                state: this.sousuo.state,
                status: this.sousuo.status,
                batch: this.sousuo.batch,
            }).then((res) => {
                this.loading = false;
                if (res.code != 200) {
                    this.$Message({
                        type: "info",
                        message: res.msg,
                    });
                } else {
                    this.DataList = res.data.data
                    return;
                }
            })
            setTimeout(() => {
                //转换成excel时，使用原始的格式
                var xlsxParam = { raw: true };
                let fix = document.querySelector(".el-table__fixed-right");
                let wb;
                //判断有无fixed定位，如果有的话去掉，后面再加上，不然数据会重复
                if (fix) {
                    wb = XLSX.utils.table_to_book(
                        this.$refs.multipleTable.$el.removeChild(fix), xlsxParam
                    );
                    this.$refs.multipleTable.$el.appendChild(fix);
                } else {
                    wb = XLSX.utils.table_to_book(this.$refs.multipleTable.$el, xlsxParam);
                }
                var wbout = XLSX.write(wb, {
                    bookType: "xls",
                    bookSST: true,
                    type: "array",
                });
                try {
                    // 如果是IE浏览器，使用Blob通过navigator.msSaveBlob保存
                    if (navigator.msSaveBlob) {
                        navigator.msSaveBlob(new Blob([wbout], { type: 'application/octet-stream' }), '卡密列表.xlsx');
                    } else {
                        // 在其他浏览器中使用file-saver保存文件
                        saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '卡密列表.xlsx');
                    }
                } catch (e) {
                    if (typeof console !== 'undefined') console.log(e, wbout);
                }
                return wbout;
            }, 1000);
            setTimeout(() => {
                this.getdata(1)
            }, 2000);
        },
        // 修改审核状态
        upShenheZuopin() {
            let data = {
                id: this.id,
                status: this.status,
            }
            upCard(data).then(res => {
                if (res.code == 200) {
                    this.$message.success(res.msg)
                    this.editFormUpShenhe = false
                    this.status = ''
                    this.getdata(1)
                } else {
                    this.$message.error(res.msg)
                    this.editFormUpShenhe = false
                    this.status = ''
                    this.getdata(1)
                }
            })


        },
        // 关闭状态编辑页
        closeUpShenhe() {
            this.editFormUpShenhe = false
            this.status = ''
            this.$message({
                type: 'info',
                message: '已取消修改'
            })
        },
        // 打开状态编辑页
        upShenhe(row) {
            this.editFormUpShenhe = true;
            this.id = row.id;
        },
        // 重置数据
        chongzhi() {
            this.sousuo.status = ''
            this.sousuo.state = ''
            this.sousuo.batch = ''
            this.getdata(1)
        },
        // 搜索数据
        search() {
            this.getdata(1);
        },
        // 获取标签列表
        gteBatch() {
            getCardBatchList().then((res) => {
                this.loading = false;
                if (res.code != 200) {
                    this.$Message({
                        type: "info",
                        message: res.msg,
                    });
                } else {
                    res.data.list.forEach((item) => {
                        this.optionsBatch.push({ label: item.batchName, value: item.id })
                    })
                    return;
                }
            })
        },
        // 卡密类型
        Type: function (row) {
            if (row.type == 0) {
                return "钻石"
            } else if (row.type == 1) {
                return "奖学金"
            }
        },
        // 批次状态
        State: function (row) {
            if (row.state == 0) {
                return "禁用"
            } else if (row.state == 1) {
                return "启用"
            }
        },
        // 状态
        Status: function (row) {
            if (row.status === 0) {
                return '待使用'
            } else if (row.status === 1) {
                return '已使用'
            } else if (row.status === 2) {
                return '停用'
            }
        },
        // 添加
        addData() {
            // this.loading = true
            generateCards(this.xiugai).then((res) => {
                this.loading = false;
                if (res.code == 200) {
                    this.editFormVisiible = false
                    this.$message.success(res.msg)
                    this.getdata(1)
                } else {
                    this.editFormVisiible = false
                    this.$message.error(res.msg);
                }
            })
        },
        // 打开编辑器
        OpenBianji() {
            this.editFormVisiible = true;
            this.tit = "添加";
            this.xiugai.id = '';
            this.xiugai.num = '';
            this.xiugai.money = '';
            this.xiugai.batch = '';
            this.xiugai.type = '';
        },
        // 关闭编辑对话框
        closeDialog() {
            this.editFormVisiible = false
            this.$message({
                type: 'info',
                message: '已取消编辑'
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.pageparm.page = parm.currentPage
            this.getdata(parm.currentPage)
        },
        // 获取数据
        getdata(page) {
            this.loading = true;
            getCardList({
                state: this.sousuo.state,
                status: this.sousuo.status,
                batch: this.sousuo.batch,
                page: (page - 1) * 20,
            }).then((res) => {
                this.loading = false;
                if (res.code != 200) {
                    this.$Message({
                        type: "info",
                        message: res.msg,
                    });
                } else {
                    this.DataList = res.data.list;
                    this.pageparm.currentPage = page;
                    this.pageparm.total = res.data.count;
                    return;
                }
            })
        },
    }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/Cami/Cami.vue